import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";

export default function NewsCard({ item }: { item: NewsItem }) {
  return (
    <Link
      to={`/news/detail/${item.id}`}
      className="group flex flex-col sm:flex-row rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full sm:w-56 shrink-0 aspect-[16/10] sm:aspect-auto sm:h-40 overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} 动漫资讯`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex-1 p-4 md:p-5 flex flex-col">
        <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2 flex-wrap">
          <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-800 font-medium">
            {item.category}
          </span>
          <span>{item.date}</span>
          <span className="hidden sm:inline w-1 h-1 rounded-full bg-background-400"></span>
          <span className="hidden sm:inline">{item.source}</span>
        </div>
        <h3 className="font-heading font-bold text-foreground-950 text-base md:text-lg leading-snug line-clamp-2 group-hover:text-primary-700 transition-colors">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed hidden sm:block">
          {item.summary}
        </p>
        <span className="mt-auto pt-3 text-sm text-primary-700 flex items-center gap-1 font-medium">
          阅读全文
          <i className="ri-arrow-right-s-line text-base"></i>
        </span>
      </div>
    </Link>
  );
}